<template>
  <div class="KahiDetailRelation" v-bind:class="{ link: isLink }">
    <p v-html="breakLineUta(kahi.uta2, 3, splice)"></p>
    <kahi-meta-info
      v-bind:display-type="'relation'"
      v-bind:saku="kahi.saku2"
      v-bind:volume="kahi.volume"
      v-bind:kno="kahi.kno2"
    ></kahi-meta-info>
    <div class="KahiDetailRelationDistance" v-if="hasDistance">
      現在地から{{ convertDistance(distance) }}
    </div>
  </div>
</template>

<script lang="ts" src="./KahiDetailRelation.ts"></script>
<style scoped lang="scss" src="./KahiDetailRelation.scss"></style>
